module.exports = __webpack_public_path__ + "img/michaela-markus.42500665.jpg";